<template>
  <v-app id="inspire" v-if="isSpecialRoute()">
    <router-view />
  </v-app>
  <v-app id="inspire" v-else @bjjlink-connect-app-login="appLogin">
    <v-sheet height="100%" tile elevation="0" class="auto-login-loader" fill-height v-if="appAutoLogin == 'yes'">
      <v-progress-linear indeterminate color="primary" height="20"></v-progress-linear>
      <v-card-text class="text-caption text-center">
        {{ $t('message.loading_jiu_jitsu') }}
      </v-card-text>
    </v-sheet>
    <v-navigation-drawer v-model="drawer" :temporary="isSmallerDisplay() ? true : false" app>
      <BeltContainer v-if="userPanel" :height="50" :belt="userPanel.belt"></BeltContainer>
      <v-card-actions class="text-center clickable" style="margin-top:-40px">
        <CountryFlag v-if="userPanel" style="margin-top:40px" size="25" :avatar="true"
          :country-code="userPanel.nationality">
        </CountryFlag>
        <v-spacer></v-spacer>
        <UserAvatar v-if="userPanel" :enable-link="true" :user="userPanel" :store-image="true" size="80"
          :small-badge="true" :offset-x="20">
        </UserAvatar>
        <v-spacer></v-spacer>
        <v-btn icon style="margin-top:40px" @click="loadIdCard()">
          <v-icon>mdi-card-account-details-outline</v-icon>
        </v-btn>
      </v-card-actions>
      <div v-if="userPanel" class="text-center text-caption font-weight-black">
        {{ userPanel.displayName }}
      </div>
      <v-list dense>
        <v-list-item-group v-model="selectedMenuItem" color="primary">
          <v-list-item @click="navigateTo({ name: 'home-member', query: { v: appVersion } })">
            <v-list-item-icon>
              <v-icon>mdi-home-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ $t("message.home") }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item v-if="$store.state.userManagedAcademy"
            @click="navigateTo({ name: 'myacademytab', params: { tabId: 0 } })">
            <v-list-item-icon>
              <v-icon>mdi-bank</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                {{ $t("message.my_academy") }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click="navigateTo({ name: 'inbox' })">
            <v-list-item-icon>
              <v-badge color="error"
                v-if="$store.state.isUserLoggedIn && !$store.state.hidden && $store.state.messagesCount > 0" right
                :content="$store.state.messagesCount">
                <v-icon>mdi-mailbox-open-up-outline</v-icon>
              </v-badge>
              <v-icon v-else>mdi-mailbox-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ $t("message.messages") }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click="navigateTo({ name: 'notifications' })">
            <v-list-item-icon>
              <v-badge color="error" v-if="$store.state.isUserLoggedIn && $store.state.notificationsCount > 0" right
                :content="$store.state.notificationsCount">
                <v-icon>mdi-bell-outline</v-icon>
              </v-badge>
              <v-icon v-else>mdi-bell-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ $t("message.notifications") }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click="navigateTo({ name: 'myevents' })">
            <v-list-item-icon>
              <v-icon>mdi-calendar-multiple-check</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ $t("message.my_events") }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click="navigateTo({ name: 'waivers' })">
            <v-list-item-icon>
              <v-icon>mdi-draw-pen</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ $t("message.documents") }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="$store.state.userManagedAcademy" @click.stop="navigateTo({ name: 'viewtimers' });">
            <v-list-item-icon>
              <v-icon>mdi-timer-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ $t("message.timers") }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click.stop="navigateTo({ name: 'affiliates' });">
            <v-list-item-icon>
              <v-icon>mdi-account-tie-voice-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ $t("message.referrals_programs") }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item @click.stop="navigateTo({ name: 'ibjjftournaments' });">
            <v-list-item-icon>
              <v-icon>mdi-tournament</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ $t("message.match_tracker") }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click.stop="navigateTo({ name: 'lineagetree' });">
            <v-list-item-icon>
              <v-icon>mdi-family-tree</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ $t("message.menu_lineage_tree") }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click.stop="navigateTo({ name: 'users' });">
            <v-list-item-icon>
              <v-icon>mdi-account-group-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ $t("message.users") }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click.stop="navigateTo({ name: 'academies' });">
            <v-list-item-icon>
              <v-icon>mdi-bank</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ $t("message.academies") }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click="navigateTo({ name: 'events' })">
            <v-list-item-icon>
              <v-icon>mdi-calendar-month-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ $t("message.events") }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="!$store.state.hidden && !isSmallerDisplay()" @click="navigateTo({ name: 'map' })">
            <v-list-item-icon>
              <v-icon>mdi-earth</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ $t("message.explore") }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="!$store.state.hidden"
            @click="navigateTo({ name: 'viewposts', params: { feed: 'world' } })">
            <v-list-item-icon>
              <v-icon>mdi-forum</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ $t("message.community") }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="$store.state.needsApp" @click="downloadApp()" color="secondary">
            <v-list-item-icon>
              <v-icon color="error">mdi-cellphone-arrow-down-variant</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ $t("message.download_app") }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
        </v-list-item-group>
        <v-list-group @click.stop="doNothing()" :value="false" prepend-icon="mdi-account-circle">
          <template v-slot:activator>
            <v-list-item-title @click.stop="doNothing()">{{ $t("message.profile") }}</v-list-item-title>
          </template>
          <v-list-item @click="navigateTo({ name: 'viewprofile', params: { userId: $store.state.user._id } })">
            <v-list-item-icon>
              <v-icon>mdi-account-box-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                {{ $t("message.view") }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click="navigateTo({ name: 'editprofile' })">
            <v-list-item-icon>
              <v-icon>mdi-square-edit-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                {{ $t("message.edit") }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click.stop="navigateTo({ name: 'edithistory' })">
            <v-list-item-icon>
              <v-icon>mdi-history</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                {{ $t("message.belts_and_history") }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click="navigateTo({ name: 'settings' })">
            <v-list-item-icon>
              <v-icon>mdi-tune-variant</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                {{ $t("message.settings") }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click="inviteFriendsDialog = true">
            <v-list-item-icon>
              <v-icon>mdi-account-multiple-plus-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                {{ $t("message.invite_friends") }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="!isSmallerDisplay()" @click="toggleThemeColor()">
            <v-list-item-icon>
              <v-icon color="#1A237E" v-if="!isDarkTheme()">mdi-weather-night</v-icon>
              <v-icon color="#FFCA28" v-else>mdi-weather-sunny</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-if="!isDarkTheme()">
                {{ $t("message.dark_mode") }}
              </v-list-item-title>
              <v-list-item-title v-else>
                {{ $t("message.light_mode") }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="!$store.state.inApp" @click="logout()">
            <v-list-item-icon>
              <v-icon>mdi-logout</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                {{ $t("message.logout") }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
        <v-divider></v-divider>
        <v-list-item v-if="$store.state.managedAcademyAdmin && !$store.state.inApp" @click="openAdmin()">
          <v-list-item-icon>
            <img class="mr-1" style="margin-bottom:-4px" width="25" height="25"
              :src="assets() + '/logos/logo_admin.png'" />
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              Admin+
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item @click="navigateTo({ name: 'viewourterms' })">
          <v-list-item-icon>
            <v-icon>mdi-file-document-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              {{ $t("message.terms_of_use") }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item @click="reload()">
          <v-list-item-icon>
            <v-icon>mdi-cube-scan</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              v{{ appVersion }}
              <span class="ml-1" v-if="isAppAdmin()">[inApp: {{ $store.state.inApp }}]</span>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-footer>
        <v-card-text class="text-center">
          <div>
            <p style="font-size: 12px;">{{ $t("message.powered_by") }}</p>
          </div>
          <div class="bottom-nav-logomt-1">
            <b>MARTIAL ARTS</b> TECHNOLOGY
          </div>
        </v-card-text>
      </v-footer>
    </v-navigation-drawer>
    <v-app-bar app flat v-if="!hideNavigations" dense>
      <div @click="goToHomeOrRefresh()">
        <v-progress-circular style="margin-left: 15px" size="25" v-if="refreshingPage" indeterminate
          color="primary"></v-progress-circular>
        <img class="clickable" style="width:50px;margin-top:-5px" v-if="!refreshingPage && $vuetify.theme.dark"
          :src="assets('logos/bjjlink-2025-white.png')" />
        <img class="clickable" style="width:50px;margin-top:-5px" v-else-if="!refreshingPage"
          :src="assets('logos/bjjlink-2025-black.png')" />
      </div>
      <v-spacer></v-spacer>
      <v-btn v-if="!isHome()" icon @click="goBack()">
        <v-icon size="25">mdi-chevron-left</v-icon>
      </v-btn>
      <v-btn v-if="$store.state.isUserLoggedIn && $store.state.notificationsCount > 0" class="mb-1" icon
        @click="navigateTo({ name: 'notifications' })">
        <v-badge overlap dot color="error" right :content="$store.state.notificationsCount">
          <v-icon size="25">mdi-bell-ring-outline</v-icon>
        </v-badge>
      </v-btn>
      <v-btn class="mb-1" v-else icon @click="navigateTo({ name: 'notifications' })">
        <v-icon size="25">mdi-bell-outline</v-icon>
      </v-btn>
      <v-badge v-if="$store.state.messagesCount" color="error" dot overlap>
        <v-avatar @click="toggleDrawer()" size="25px" class="grey lighten-4 clickable ml-1 mb-1" icon>
          <img v-if="!$store.state.userImage" :src="assets('blank-profile-picture.png')" alt="avatar" />
          <ImageDisplay v-else :src="$store.state.userImage" alt="avatar" />
        </v-avatar>
      </v-badge>
      <v-avatar v-else @click="toggleDrawer()" size="25px" class="grey lighten-4 clickable ml-1 mb-1" icon>
        <img v-if="!$store.state.userImage" :src="assets('blank-profile-picture.png')" alt="avatar" />
        <ImageDisplay v-else :src="$store.state.userImage" alt="avatar" />
      </v-avatar>
    </v-app-bar>
    <v-main>
      <v-container class="pa-0">
        <router-view :refresh-page="refreshingPage" />
      </v-container>
    </v-main>
    <v-dialog v-model="pointsDialog">
      <v-card outlined>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn icon small @click="pointsDialog = false"><v-icon>mdi-close-circle</v-icon></v-btn>
        </v-card-actions>
        <v-card-title>{{ $t("message.points") }}</v-card-title>
        <v-list dense>
          <v-list-item dense>
            <v-list-item-content>
              {{ $t("message.total_points") }}
            </v-list-item-content>
            <v-list-item-action>
              {{ header.points.total }}
            </v-list-item-action>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item dense>
            <v-list-item-content>
              {{ $t("message.last_30_days") }}
            </v-list-item-content>
            <v-list-item-action>
              {{ header.points.last30Days }}
            </v-list-item-action>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item dense>
            <v-list-item-content>
              {{ $t("message.this_month") }}
            </v-list-item-content>
            <v-list-item-action>
              {{ header.points.thisMonth }}
            </v-list-item-action>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item dense>
            <v-list-item-content>
              {{ $t("message.academy_position") }}
            </v-list-item-content>
            <v-list-item-action>
              {{ header.positions.academyPosition }}
            </v-list-item-action>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item dense>
            <v-list-item-content>
              {{ $t("message.city_position") }}
            </v-list-item-content>
            <v-list-item-action>
              {{ header.positions.cityPosition }}
            </v-list-item-action>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item dense>
            <v-list-item-content>
              {{ $t("message.country_position") }}
            </v-list-item-content>
            <v-list-item-action>
              {{ header.positions.countryPosition }}
            </v-list-item-action>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item dense>
            <v-list-item-content>
              {{ $t("message.world_position") }}
            </v-list-item-content>
            <v-list-item-action>
              {{ header.positions.worldPosition }}
            </v-list-item-action>
          </v-list-item>
        </v-list>
        <v-card-actions>
          <v-btn elevation="0" @click="navigateTo({ name: 'points' })" block>{{ $t("message.view_more") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="idCardDialog" transition="dialog-top-transition" width="100%">
      <v-card outlined light>
        <div class="pa-2" style="overflow: hidden">
          <div v-if="loadingIDCard" class="text-center">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
          </div>
          <div v-else-if="idCard">
            <div>
              <div v-if="familyMembers && familyMembers.length > 0">
                <v-select @change="loadIdCard()" v-model="selectedFamilyMember" :items="familyMembers" item-text="name"
                  item-value="userId" :label="$t('message.select_one')" clearable outlined dense>
                </v-select>
              </div>
            </div>
            <div v-if="idCard.nationality">
              <country-flag :countryCode="idCard.nationality"></country-flag>
            </div>
            <table width="100%">
              <tr>
                <td style="vertical-align: top" class="text-center">
                  <v-avatar size="60px" class="grey lighten-4 clickable">
                    <img v-if="!idCard.image" :src="assets('blank-profile-picture.png')" alt="avatar" />
                    <ImageDisplay v-else :src="idCard.image" alt="avatar" />
                  </v-avatar>
                </td>
              </tr>
              <tr>
                <td class="text-center">
                  <div class="text-h6 truncate-text">
                    {{ idCard.name }}
                  </div>
                  <div v-if="idCard.academy" class="text-subtitle-2 truncate-text">
                    {{ idCard.academy }}
                  </div>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <div v-if="idCard.membershipStatus" class="text-center text-h4 pa-2">
                    <div v-if="idCard.membershipStatus == 'active' || idCard.membershipStatus == 'trialing'"
                      class="success--text">
                      {{ $t("message.active").toUpperCase() }}
                    </div>
                    <div v-else class="error--text">
                      {{ $t("message.inactive").toUpperCase() }}
                    </div>
                  </div>
                </td>
              </tr>
            </table>
            <div v-if="idCard && idCard.verificationUrl" class="text-center pa-2">
              <div class="text-caption">{{ $t('message.scan_to_verify_membership') }}</div>
              <div>
                <vue-qr :text="idCard.verificationUrl" :size="200"></vue-qr>
              </div>
            </div>
            <div v-if="idCard" class="text-center pa-2">
              <VerificationBadges :verified-belts="idCard.verifiedBelts" :ibjjf-competitor="idCard.ibjjfCompetitor">
              </VerificationBadges>
            </div>
            <v-card-actions>
              <v-avatar v-if="idCard.academyImage" size="25px" class="grey lighten-4 clickable">
                <ImageDisplay :src="idCard.academyImage" alt="avatar" />
              </v-avatar>
              <v-spacer></v-spacer>
              <div class="text-right text-caption" v-if="idCard.memberSince">
                <span class="mr-1">{{ $t("message.member_since") }}</span>
                <span>{{ $d(new Date(idCard.memberSince), 'month_day_year', this.$i18n.locale) }}</span>
              </div>
            </v-card-actions>
          </div>
          <div v-else class="text-center error--text text-h6">
            {{ $t('message.invalid') }}
          </div>
        </div>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import AcademyService from "@/services/AcademyService";
import AuthenticationService from "@/services/AuthenticationService";
import ConnectService from "@/services/ConnectService";
import { Environment } from "@/services/Environment";
import UserService from "@/services/UserService";
import UtilService from "@/services/UtilService";

import BeltContainer from "@/components/displays/BeltContainer";
import CountryFlag from "@/components/displays/CountryFlagDisplay.vue";
import UserAvatar from "@/components/displays/UserAvatarDisplay";
import VerificationBadges from "@/components/displays/VerificationBadges.vue";
import VueQr from 'vue-qr';

export default {
  name: 'BJJLINKSocial',
  components: {
    CountryFlag,
    BeltContainer,
    UserAvatar,
    VerificationBadges,
    VueQr,
  },
  data() {
    return {
      elevateDialog: false,
      appAutoLogin: this.$route.query.autologin,
      embed: this.$route.query.embed,
      lat: this.$route.query.lat,
      lon: this.$route.query.lon,
      selectedMenuItem: 0,
      hideNavigations: false,
      drawer: false,
      darkTheme: true,
      newMessageDialog: false,
      testAppMessage: "Santi",
      topMessage: "Test",
      searchPanel: false,
      iconSize: "23px",
      panelHeight: null,
      idCard: null,
      refreshingPage: false,
      loadingIDCard: false,
      idCardDialog: null,
      userPanel: null,
      familyMembers: [],
      header: { points: {}, positions: {} },
      newsPanel: null,
      pointsDialog: null,
      termsLink: "https://www.bjjlink.com/terms-conditions",
      appVersion: Environment.get("VUE_APP_VERSION")
    };
  },
  async created() {
    this.drawer = this.isSmallerDisplay() ? false : true;
    if (this.lat && this.lon) {
      //store this for future use
      this.$store.dispatch("setLat", this.lat);
      this.$store.dispatch("setLon", this.lon);
    } else {
      this.lat = this.$store.state.lat;
      this.lon = this.$store.state.lon;
    }
    if (this.embed && this.embed == 'true') {
      this.hideNavigations = true;
    }
    //First thiings first: Hide loader
    let initialLoader = document.getElementById('app_loader_container');
    if (initialLoader)
      initialLoader.parentNode.removeChild(initialLoader);
    if (this.$store.state.language) {
      this.$store.dispatch("setLanguage", this.$store.state.language);
      this.$i18n.locale = this.$store.state.language;
    } else this.userLang = "en";

    const rawPath = window.location.pathname;
    const isAuthPage = rawPath.indexOf("login") >= 0 || rawPath.indexOf("applogin") >= 0;

    if (!isAuthPage) {
      this.userPanel = await this.getMe();
      if (this.userPanel) {
        this.darkTheme = this.userPanel.darkMode;
        this.$vuetify.theme.dark = this.darkTheme;
        let theme = this.darkTheme ? 'dark' : 'light';

        this.$store.dispatch("setTheme", theme);
        this.$store.dispatch("setLanguage", this.userPanel.language);
        this.$i18n.locale = this.userPanel.language;
      }
    }
  },
  async mounted() {
    const windowHeight = window.innerHeight - 50;//64 is the header fixed height
    if (!this.isSmallerDisplay()) {
      const leftPanelheight = 877;
      if (windowHeight > leftPanelheight)
        this.panelHeight = windowHeight;
      else
        this.panelHeight = leftPanelheight;
    } else {
      this.panelHeight = windowHeight;
    }
    // Set initial menu selection based on current route
    this.updateSelectedMenuItem();
  },
  watch: {
    '$route'() {
      this.updateSelectedMenuItem();
    }
  },
  methods: {
    updateSelectedMenuItem() {
      const routeName = this.$route.name;
      let menuIndex = -1;

      if (routeName === 'home-member' || routeName === 'home-regular' || routeName === 'home') {
        menuIndex = 0; // Home
      } else if (routeName === 'myacademytab' && this.$store.state.userManagedAcademy) {
        menuIndex = 1; // My Academy (only if user has managed academy)
      } else if (routeName === 'inbox') {
        menuIndex = this.$store.state.userManagedAcademy ? 2 : 1; // Messages
      } else if (routeName === 'notifications') {
        menuIndex = this.$store.state.userManagedAcademy ? 3 : 2; // Notifications
      } else if (routeName === 'myevents') {
        menuIndex = this.$store.state.userManagedAcademy ? 4 : 3; // My Events
      } else if (routeName === 'waivers') {
        menuIndex = this.$store.state.userManagedAcademy ? 5 : 4; // Documents
      } else if (routeName === 'affiliates') {
        menuIndex = this.$store.state.userManagedAcademy ? 6 : 5; // Referrals Programs
      } else if (routeName === 'lineagetree') {
        menuIndex = this.$store.state.userManagedAcademy ? 7 : 6; // Lineage Tree
      } else if (routeName === 'users') {
        menuIndex = this.$store.state.userManagedAcademy ? 8 : 7; // Users
      } else if (routeName === 'academies') {
        menuIndex = this.$store.state.userManagedAcademy ? 9 : 8; // Academies  
      } else if (routeName === 'events') {
        menuIndex = this.$store.state.userManagedAcademy ? 10 : 9; // Events
      } else if (routeName === 'map') {
        menuIndex = this.$store.state.userManagedAcademy ? 11 : 10; // Explore
      } else if (routeName === 'viewposts') {
        menuIndex = this.$store.state.userManagedAcademy ? 12 : 11; // Community
      }

      if (menuIndex >= 0) {
        this.selectedMenuItem = menuIndex;
      } else {
        this.selectedMenuItem = null;
      }
    },
    downloadApp() {
      const os = this.getOS();
      if (os == 'Mac OS' || os == 'iOS') {
        this.goToLink(
          'https://apps.apple.com/us/app/bjjlink/id6743326231'
        );
      } else if (os == 'Android') {
        this.goToLink(
          'https://play.google.com/store/apps/details?id=com.mixedmartialarts.bjjlinkconnect'
        );
      }
    },
    reloadNewApp() {
      window.location.replace('https://connect.bjjlink.com')
    },
    isHome() {
      let currentPage = this.$router && this.$router.history && this.$router.history.current ? this.$router.history.current.name : null;
      if (currentPage.indexOf('home') >= 0)
        return true;
      return false;
    },
    async goToHomeOrRefresh() {
      const currentPage = this.$router && this.$router.history && this.$router.history.current
        ? this.$router.history.current.name
        : null;
      const isOnHome = currentPage === 'home-member' || currentPage === 'home-regular';

      if (!isOnHome) {
        // Not on home — navigate there immediately, no version check needed
        this.navigateTo({ name: 'home-member', query: { v: this.appVersion } });
        return;
      }

      // Already on home — check for a new version and refresh if one exists
      const currentVersion = this.appVersion;
      if (!currentVersion) {
        // Version not yet loaded; skip reload to avoid false positive
        return;
      }
      const backendVersion = await UtilService.latestVersion(true);
      if (backendVersion && backendVersion.version && backendVersion.version != currentVersion) {
        console.log(`🚀 New Version Detected: ${backendVersion.version}. Forcing Webview Refresh...`);
        if ('serviceWorker' in navigator) {
          navigator.serviceWorker.getRegistrations().then(registrations => {
            for (const registration of registrations) {
              registration.unregister();
            }
          });
        }
        window.sessionStorage.clear();
        const url = new URL(window.location.href);
        url.searchParams.set('v', backendVersion.version);
        url.searchParams.set('t', Date.now());
        window.location.replace(url.toString());
      } else if (!this.refreshingPage) {
        this.refreshingPage = true;
        const vm = this;
        setTimeout(function () {
          vm.refreshingPage = false;
        }, 2000);
      }
    },
    async appLogin(jsonString) {
      if (!jsonString) {
        return;
      }
      try {
        const data = JSON.parse(jsonString)
        const token = data ? data.token : null;
        this.$store.dispatch("setInApp", true);
        if (token && (!localStorage.token || localStorage.token != token)) {
          this.$store.dispatch("setToken", data.token);
          this.$store.dispatch("setUser", data.user);
          this.$store.dispatch("setName", data.user.fName);
          this.$store.dispatch("setHidden", data.user.hidden);
          this.$store.dispatch("setUserImage",
            (data.user.userImageSmall ?
              data.user.userImageSmall :
              data.user.userImage));
          this.$store.dispatch("setLanguage", data.user.lang);
          this.$i18n.locale = data.user.lang;
          localStorage.token = data.token;
          if (
            data.hasLatestAgreement &&
            data.hasLatestAgreement == true
          ) {
            localStorage.hasAgreements = true;
            this.$store.dispatch("setHasAgreements", true);
          } else {
            localStorage.hasAgreements = false;
            this.$store.dispatch("setHasAgreements", false);
          }
          let redirectLocation = '/secure/home?login=true'
          if (this.specialRoute && this.specialRoute == 'checkin')
            redirectLocation = 'https://admin.bjjlink.com/secure/pickacademy'
          else if (this.to == 'elevate')
            redirectLocation = 'https://elevate.bjjlink.com';
          else if (this.to == 'admin')
            redirectLocation = 'https://admin.bjjlink.com';
          else if (
            data.user.totalHistory &&
            data.user.totalHistory > 0
          )
            redirectLocation = '/secure/home?login=true';
          else
            redirectLocation = '/secure/history';
          this.appAutoLogin = null;
          console.log('Redirecting after AppLogin: ', redirectLocation);
          window.location.replace(redirectLocation);
        } else {
          console.log('BJJLINK Connect: We did not try to log in. JSON: ', jsonString)
        }
      } catch (err) {
        console.log('Error AppLogin in social: ', err);
      }
    },
    toggleThemeColor() {
      this.darkTheme = !this.darkTheme;
      this.$vuetify.theme.dark = this.darkTheme;
      //push color update
      let theme = 'light';
      if (this.darkTheme)
        theme = 'dark';
      this.$store.dispatch("setTheme", theme);
      //Make Api Call
      UserService.toggleTheme();
      this.$router.go();
    },
    getFamilyMembers() {
      if (this.managedAcademy) {
        AcademyService.academyFamily(this.managedAcademy)
          .then((data) => {
            if (data && data.members && data.members.length > 0) {
              const familyMembers = [{
                name: this.$t('message.you'),
                userId: null
              }];
              this.familyMembers = familyMembers.concat(data.members);
            }
          });
      }
    },
    async loadIdCard() {
      if (!this.idCardDialog)
        this.getFamilyMembers()
      this.idCardDialog = true;
      this.loadingIDCard = true;
      const me = await ConnectService.getMe(true, this.selectedFamilyMember);
      if (me.data && me.data.idCard) {
        this.idCard = me.data.idCard;
      }
      this.loadingIDCard = false;
      this.trackEvent('user', 'view_id_card', this.$store.state.user._id);
    },
    async reload() {
      const currentVersion = this.appVersion;
      const backendVersion = await UtilService.latestVersion(true);
      if (backendVersion && backendVersion.version && backendVersion.version != currentVersion) {
        console.log('Not current version[' + currentVersion + ' vs ' + backendVersion.version + ']! Reloading entire app');
        const url = new URL(window.location.href);
        url.searchParams.set('v', backendVersion.version);
        window.location.replace(url.toString());
      } else {
        window.location.reload(true);
      }
    },
    showElevateDialog() {
      this.elevateDialog = !this.elevateDialog;
    },
    goToElevate() {
      this.elevateDialog = false;
      UserService.logActivity({
        activityType: "clicked_elevate_menu"
      });
      window.open("/elevate");
    },
    openAdmin() {
      //const os = this.getOS();
      //const size = this.$vuetify.breakpoint.name;
      /*
        if (os == 'Mac OS' && size != 'lg' && size != 'xl') {//This should be an ipad
          console.log('BLAh')
          //window.open("/admin");
        } else 
      */
      if (this.isSmallerDisplay() && this.$store.state.inApp) {
        window.location = "/secure/home?inApp=true";
      } else {
        window.open("https://admin.bjjlink.com/secure/home?inApp=false");
      }
    },
    updatePanels() {
      console.log('We dont update panels anymore')
      /*
      if (data) {
        if (data.userPanel) {
          this.userPanel = data.userPanel;
          const vm = this;
          setTimeout(function () {
            vm.userPanel = data.userPanel;
          }, 1000);
        }
        if (data.suggestionsPanel) {
          this.suggestionsPanel = null;
          const vm = this;
          setTimeout(function () {
            vm.suggestionsPanel = data.suggestionsPanel;
          }, 500);
        }
        if (data.newsPanel) {
          this.newsPanel = null;
          const vm = this;
          setTimeout(function () {
            vm.newsPanel = data.newsPanel;
          }, 500);
        }
      }
      */
    },
    reloadToSettings() {
      window.location.replace("/secure/settings");
    },
    toggleDrawer() {
      this.drawer = !this.drawer;
    },
    menuColor(menu) {
      if (this.$route && this.$route.path.indexOf(menu) >= 0) {
        return this.themeColor('primary');
      } else {
        return this.darkTheme ? "white" : "grey";
      }
    },
    closeSearchPanel() {
      this.searchPanel = false;
      this.menuElements = true;
    },
    isSpecialRoute() {
      const path = this.$route ? this.$route.path : null;
      if (!path)
        return false;
      if (
        path == "/landing" ||
        path == "/login" ||
        path == "/qr" ||
        path == "/help" ||
        path == "/register" ||
        path == "/secure/admin/managedacademiesstats" ||
        path == "/registertwo" ||
        path == "/secure/admin/internalaggregates" ||
        path == "/info" ||
        path == "/bjjworld" ||
        path == "/infospa" ||
        path == "/matburn" ||
        path == "/aboutsocialnetwork" ||
        path == "/aboutadminconsole" ||
        path == "/secure/admin-reports" ||
        path.indexOf("/info/") >= 0 ||
        path.indexOf("pub") >= 0 ||
        path.indexOf("update-email") >= 0 ||
        path.indexOf("applogin") >= 0 ||
        path.indexOf("forgot-password") >= 0 ||
        path.indexOf("reset-password") >= 0 ||
        path == "/"
      ) {
        return true;
      } else {
        return false;
      }
    },
    logout() {
      AuthenticationService.logout();
      this.$store.dispatch("setToken", null);
      this.$store.dispatch("setUser", null);
      this.$store.dispatch("setInApp", null);
      localStorage.removeItem("token");
      window.location.replace("/login");
    },
  }
};
</script>

<style>
.auto-login-loader {
  position: absolute;
  z-index: 1000000;
  width: 100%;
  height: 100%;
}

.clickable {
  cursor: pointer;
}

.hero-button {
  margin-top: -7px
}

.hero-icon {
  margin-top: -7px
}

.info-box {
  max-height: 380px;
  overflow-y: auto;
}

.border-light {
  border: 1px solid #E0E0E0
}

.border-dark {
  border: 1px solid #424242
}

.router-col {
  overflow-y: auto;
  display: flex;
  flex-flow: column;
  position: relative;
}

.rotate-90 {
  -webkit-transform: rotate(180deg);
  -moz-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  -o-transform: rotate(180deg);
  transform: rotate(180deg);
}

.rotate {
  transform: rotate(90deg);
}

.page-description {
  overflow-y: auto;
  max-height: 250px;
  overflow-x: auto;
  white-space: pre-wrap;
  white-space: -moz-pre-wrap;
  white-space: -pre-wrap;
  white-space: -o-pre-wrap;
  word-wrap: break-word;
}

.format-text {
  white-space: pre-wrap;
  white-space: -moz-pre-wrap;
  white-space: -pre-wrap;
  white-space: -o-pre-wrap;
  word-wrap: break-word;
}


.user-list-container {
  overflow-y: auto;
  max-height: 250px;
}

.center-panel {
  margin: 0 auto;
}

.rounded-card {
  border-radius: 25px !important;
}

.header-column {
  z-index: 10;
}
</style>
